import localStorage from 'local-storage';

export const SET_IS_COOKIE_HIDDEN = 'BEAMLY/CCX/SET_IS_COOKIE_HIDDEN';

export const setIsCookieHidden = storageValue => ({
  type: SET_IS_COOKIE_HIDDEN,
  storageValue,
});

const setLocalStorageValue = () => localStorage.set('isCookieHidden', true);

export const hideCookie = () => ((dispatch) => {
  const cookieSetValue = setLocalStorageValue();

  if (cookieSetValue === true) {
    return dispatch(setIsCookieHidden(true));
  }

  return false;
});

export const showCookie = () => dispatch => dispatch(setIsCookieHidden(false));

const watchStorageUpdates = (dispatch) => {
  localStorage.on('isCookieHidden', (storageValue) => {
    if (storageValue === true) {
      return dispatch(setIsCookieHidden(true));
    }

    return dispatch(showCookie());
  });
};

const readLocalStorageValue = () => localStorage.get('isCookieHidden');

export const readCookie = () => ((dispatch) => {
  const cookieValue = readLocalStorageValue();
  watchStorageUpdates(dispatch);

  if (cookieValue === true) return dispatch(hideCookie());

  return dispatch(showCookie());
});
